module.exports = __webpack_public_path__ + "static/3-a96fc4b9f9163bc317ce7ffda0290649.png";